export default {
  AGREEMENT_REGISTRATION: 'AGREEMENT_REGISTRATION',
  AGREEMENT_WITHDRAWAL: 'AGREEMENT_WITHDRAWAL',
  TRANSACTION_CONFIRMATION: 'TRANSACTION_CONFIRMATION',
};
